import { Button, Form, DatePicker, TimePicker, InputNumber, Select } from 'antd'
import { memo, useCallback, useEffect, useState } from 'react'
import { NewTrainingGameFormData, TrainingGame, TrainingGameFormData } from 'types/games'
import dayjs from 'dayjs'
import { getTrainingFields } from 'services/training-fields'
import { TrainingField } from 'types/fields'

const { RangePicker } = TimePicker

type Props = {
    item: TrainingGame
    onSubmit: (item: NewTrainingGameFormData) => void
    loading: boolean
}

export const TrainingGameForm = memo((props: Props) => {
    const { item, onSubmit, loading } = props
    const [fields, setFields] = useState<TrainingField[]>([])

    const onFinish = useCallback(
        (values: TrainingGameFormData) => {
            values.date = dayjs(values.date).format('YYYY-MM-DD')
            const timeStart = values.timeRange[0]?.format('HH:mm')
            const timeEnd = values.timeRange[1]?.format('HH:mm')

            onSubmit({
                date: values.date,
                field_id: values.field_id,
                playersCount: values.playersCount,
                reservePlayersCount: values.reservePlayersCount,
                timeStart,
                timeEnd,
            })
        },
        [onSubmit]
    )

    useEffect(() => {
        getTrainingFields().then(setFields)
    }, [])

    return (
        <Form
            name='basic'
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete='off'
            disabled={loading}
        >
            <Form.Item
                initialValue={dayjs(item.date)}
                label='Date'
                name='date'
                rules={[{ required: true, message: 'Please input date!' }]}
            >
                <DatePicker />
            </Form.Item>
            <Form.Item
                initialValue={
                    item.timeStart && item.timeEnd
                        ? [dayjs(item.timeStart, 'HH:mm'), dayjs(item.timeEnd, 'HH:mm')]
                        : null
                }
                label='Time range'
                name='timeRange'
                rules={[{ required: true, message: 'Please input time range!' }]}
            >
                <RangePicker format='HH:mm' minuteStep={10} />
            </Form.Item>
            <Form.Item
                initialValue={item.playersCount}
                label='Players count'
                name='playersCount'
                rules={[{ required: true, message: 'Please input players count!' }]}
            >
                <InputNumber />
            </Form.Item>
            <Form.Item
                initialValue={item.reservePlayersCount}
                label='Reserve players count'
                name='reservePlayersCount'
                rules={[{ required: true, message: 'Please input reserve players count!' }]}
            >
                <InputNumber />
            </Form.Item>
            <Form.Item
                initialValue={item['field_id']}
                name='field_id'
                label='Field'
                rules={[{ required: true, message: 'Please select field!' }]}
            >
                <Select>
                    {fields.map(it => (
                        <Select.Option key={it.id} value={it.id}>
                            {it.name}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type='primary' htmlType='submit'>
                    Submit
                </Button>
                <Button htmlType={'reset'}>Reset</Button>
            </Form.Item>
        </Form>
    )
})
